"use client";

import React from "react";
import { Check, Lock } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const packages = [{
  id: 1,
  title: "Starter",
  price: "990 CHF",
  isBestseller: false
}, {
  id: 2,
  title: "Professional",
  price: "1.990 CHF",
  isBestseller: true
}, {
  id: 3,
  title: "Premium",
  price: "3.490 CHF",
  isBestseller: false
}];
const packageFeatures = [{
  packageId: 1,
  text: "5 Seiten"
}, {
  packageId: 1,
  text: "Mobile optimiert"
}, {
  packageId: 1,
  text: "Kontaktformular"
}, {
  packageId: 1,
  text: "SEO Grundoptimierung"
}, {
  packageId: 1,
  text: "Lieferung in 7 Tagen"
}, {
  packageId: 2,
  text: "10 Seiten"
}, {
  packageId: 2,
  text: "Google Analytics Integration"
}, {
  packageId: 2,
  text: "Blog / News Sektion"
}, {
  packageId: 2,
  text: "SEO vollständig optimiert"
}, {
  packageId: 2,
  text: "Online-Buchungssystem"
}, {
  packageId: 2,
  text: "Lieferung in 10 Tagen"
}, {
  packageId: 3,
  text: "Alles aus Professional"
}, {
  packageId: 3,
  text: "Bis zu 20 Seiten"
}, {
  packageId: 3,
  text: "E-Commerce Shop"
}, {
  packageId: 3,
  text: "Mehrsprachig (DE/FR/IT)"
}, {
  packageId: 3,
  text: "Google Ads Setup"
}, {
  packageId: 3,
  text: "3 Monate Support inklusive"
}, {
  packageId: 3,
  text: "Lieferung in 14 Tagen"
}];
export default function UnserePakete() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="115318" id="pakete-festpreise" className="bg-background py-24 sm:py-32 overflow-visible px-4 md:px-[60px] pt-20 sm:pt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={cn("mx-auto max-w-2xl text-center mb-16 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-4xl font-default font-bold tracking-tight text-[#111827] sm:text-5xl">
            Transparente Festpreise. Keine Überraschungen.
          </h2>
          <p className="mt-4 text-lg leading-8 text-[#4B5563] font-default">
            Einmalige Zahlung. Keine Monatsgebühren. Keine versteckten Kosten.
          </p>
        </div>

        <div className="mx-auto max-w-[1200px] overflow-visible">
          <Carousel opts={{
          align: "start",
          loop: false
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6 items-stretch">
              {packages.map((pkg, i) => <CarouselItem key={pkg.id} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3 py-4">
                  <Card className={cn("relative h-full flex flex-col rounded-2xl transition-all duration-300 pt-[60px]", pkg.isBestseller ? "bg-[#0A1628] text-white shadow-xl lg:scale-105 z-10 hover:shadow-2xl" : "bg-white text-[#111827] border-2 border-[#0A1628]/10 shadow-sm hover:shadow-lg hover:border-[#0A1628]")}>
                    {pkg.isBestseller && <Badge className="bg-[#4F46E5] text-white rounded-full shadow-sm px-5 py-1 text-xs font-bold uppercase tracking-wider border-none mb-4 mx-6">
                        Beliebteste Wahl
                      </Badge>}
                    <CardHeader className="pb-8">
                      <CardTitle className={cn("font-default text-lg font-semibold", pkg.isBestseller ? "text-slate-300" : "text-[#4B5563]")}>
                        {pkg.title}
                      </CardTitle>
                      <div className="mt-4 flex items-baseline text-4xl font-default font-extrabold tracking-tight">
                        {pkg.price}
                      </div>
                      <div className="mt-1 text-[12px] text-[#9CA3AF] font-default">
                        Einmalige Zahlung · Keine Monatsgebühren
                      </div>
                    </CardHeader>
                    <CardContent className="flex-1">
                      <ul className="space-y-4 text-sm leading-6 font-default">
                        {packageFeatures.filter(f => f.packageId === pkg.id).map((feature, j) => <li key={j} data-index={j} className="flex gap-x-3">
                              <Check className={cn("h-5 w-5 flex-none", pkg.isBestseller ? "text-[#4F46E5]" : "text-[#4F46E5]")} aria-hidden="true" />
                              <span className={pkg.isBestseller ? "text-slate-300" : "text-[#4B5563]"}>
                                {feature.text}
                              </span>
                            </li>)}
                      </ul>
                    </CardContent>
                    <CardFooter className="pt-8">
                      <Button className={cn("w-full rounded-lg h-12 text-base font-default font-semibold transition-all duration-200", pkg.isBestseller ? "bg-[#4F46E5] text-white hover:bg-[#4F46E5]/90" : pkg.title === "Starter" ? "bg-white border-2 border-[#0A1628] text-[#0A1628] hover:bg-[#0A1628]/5" : "bg-[#0A1628] text-white hover:bg-[#0A1628]/90")}>
                        Jetzt starten
                      </Button>
                    </CardFooter>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <div className="flex justify-center gap-4 mt-10 lg:hidden">
              <CarouselPrevious className="static translate-y-0" />
              <CarouselNext className="static translate-y-0" />
            </div>
          </Carousel>
          
          <div className="mt-8 flex items-center justify-center gap-2 text-[14px] text-[#6B7280] font-default">
            <Lock className="h-4 w-4" />
            <span>Sicherer Kauf · Schweizer Unternehmen · Geld-zurück-Garantie bei Nichtgefallen</span>
          </div>
        </div>
      </div>
    </section>;
}